import React, { useRef } from 'react';

import { useSettingsTabsAdapter } from '../useSettingsTabsAdapter';

const ChatSettings = () => {
  const webComponentRef = useRef();
  useSettingsTabsAdapter(webComponentRef);
  return <here-chat-tab ref={webComponentRef} />;
};

export default ChatSettings;
